import React from "react";

export default function GenerateH3({ hClass, content }) {
  return <h3 className={hClass}>{content}</h3>;
}
